/***
 * 后台管理模块部分-短信充值页面对接部分
 */
import { getJSON } from 'jquery';
import { post, postJson,get } from '../axios'

const RESOURCE_BASE_PATH = '/sysMoneyAlipay';

const RESOURCE_BASE_PATH1 = '/smsOfficialAlipay';

const RESOURCE_BASE_PATH2 = '/smsTransferTable';

const RESOURCE_BASE_PATH3 = '/wxPayRecordTemporary';

const RESOURCE_BASE_PATH4 = '/unionPay';



/***
 * 查询充值包
 * @param p
 */
export const queryPriceConfig = p =>get(`${RESOURCE_BASE_PATH}/priceConfigs`, p)

/***
 * 充值弹窗回显
 * @param p
 * @returns {*}
 */
export const alipayPay = p => postJson(`${RESOURCE_BASE_PATH}/aliaAdiPay`, p)

/***
 * 查询充值记录接口
 * @param p
 */
export const queryPayRecord = p => get(`${RESOURCE_BASE_PATH}/moneyAlipay/page`, p)

/***
 * 获取当前店铺的多店铺绑定关系
 * @param p
 */
export const queryShopBindRelationList = p => post(`${RESOURCE_BASE_PATH}/queryShopBindRelationList`, p)

/** *
 * 转移短信
 * @param p
 */
export const transferSMS = p => postJson(`${RESOURCE_BASE_PATH}/transferSMS`, p)

/** *
 * 验证身份
 * @param p
 */
export const verifyIdentity = p => post(`${RESOURCE_BASE_PATH}/verifyIdentity`, p)

/** *
 * 查找转移记录
 * @param p
 */
export const querySmsTransferList = p => post(`${RESOURCE_BASE_PATH}/querySmsTransferList`, p)

/** *
 * 获取微信支付二维码等信息
 * @param p
 */
export const getWeixinQRCodeWithMessage = p => postJson(`${RESOURCE_BASE_PATH}/getWeixinQRCodeWithMessage`, p);



/** *
 * 验证是否可以关闭微信二维码窗口
 * @param p
 */
export const closeStatueVerify = p => get(`${RESOURCE_BASE_PATH3}/statueVerify`, p);



/** *
 * 微信支付
 * @param p
 */
export const wenXinPay = p => postJson(`${RESOURCE_BASE_PATH3}/wenXinPay`, p);


/** *
 * 查询官方短信充值记录
 * @param p
 */
export const officialRecords = p => get(`${RESOURCE_BASE_PATH1}/moneyAlipay/page`, p);



/** *
 * 查询短信转移列表
 * @param p
 */
export const smsPage = p => get(`${RESOURCE_BASE_PATH2}/page`, p);



/** *
 * 短信转移验证身份,检验判断
 * @param p
 */
export const verifyIdentityShore = p => get(`${RESOURCE_BASE_PATH2}/verifyIdentity`, p);



/** *
 * 短信转移
 * @param p
 */
export const trans = p => postJson(`${RESOURCE_BASE_PATH2}/trans`, p);



/** *
 * 短信转移
 * @param p
 */
export const smsVerifyCode = p => get(`${RESOURCE_BASE_PATH2}/smsVerifyCode`, p);


/***
 * 银联支付
 * @param p
 * @returns {*}
 */
 export const prePay = p => postJson(`${RESOURCE_BASE_PATH4}/prePay`, p)


 /***
 * 获取当前绑定店铺
 * @param p
 */
export const getShopBindList = p =>get(`/jdBindshopRecord/getShopBindList`, p)

//  获取自定义充值配置列表
export const getPayPriceConfigs = p =>get(`/sysMoneyAlipay/payPriceConfigs/list`, p)




